import React from "react"
import FeaturedPost from "./featuredPost"
import PostSummary from "./postSummary"
import Grid from "@material-ui/core/Grid";
import MainEventsStyles from "./events.styles";
import Box from '@material-ui/core/Box';
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

export const MainPosts = ({ posts }) => {
    const classes = MainEventsStyles();

    const featured = posts && posts.length > 0 ? posts[0] : null;
    const latest = posts && posts.length > 0 ? posts.slice(1) : [];
    return (
        <div style={{ paddingBottom: "64px" }}>
            <Box className={classes.header}>
                <Link href="/news/" color="inherit">
                    <div><Typography variant="h4">Latest News</Typography></div>
                </Link>
            </Box>
            <FeaturedPost post={featured} />

            <Grid container spacing={4} className={classes.summaryGridPadding}>
                {latest.map((post) => (
                    <Grid item xs={12} md={6} key={post.id}>
                        <PostSummary key={post.id} post={post} />
                    </Grid>
                ))}
            </Grid>

        </div>
    );
}

MainPosts.NAME = "MainPosts";
export default MainPosts
